import Loadable from "app/components/Loadable";
import { lazy } from "react";

const PondList = Loadable(lazy(() => import("./PondList")));
const PondForm = Loadable(lazy(() => import("./PondForm")));

const pondRoutes = [
  {
    path: "/Pond/PondList",
    element: <PondList />,
  },
  {
    path: "/Pond/PondForm",
    element: <PondForm />,
  },
  {
    path: "/Pond/PondForm/:pondId",
    element: <PondForm />,
  },
];

export default pondRoutes;
